export default "__VITE_ASSET__sbB9beLC__"